import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Swal from 'sweetalert2';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import { votacaoFase2 } from '../services/Votacao';

import { useGlobal } from '../contexts/global';

import iconGoogle from '../assets/images/icon_google.png';
// import iconFacebook from '../assets/images/icon_facebook_blue.svg';

import '../assets/scss/components/ModalVotacao.scss';

const ModalVotacao = () => {
  const modal = useRef();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { setShowModalVotacao, nomePizzaria, idPizzaria, zonaAtual } =
    useGlobal();

  const close = (e) => {
    e.stopPropagation();
    setShowModalVotacao(false);
  };

  const handleModal = (e) => {
    if (modal.current !== null && modal.current !== undefined) {
      if (!modal.current.contains(e.target)) {
        close(e);
      }
    }
  };

  const handleVotacao = () => {
    setIsLoading(true);
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(process.env.REACT_APP_KEY_RECAPTCHA, {
          action: 'submit'
        })
        .then(async (token) => {
          const data = {
            pizzaria_id: idPizzaria,
            email,
            token_grecaptcha: token
          };

          try {
            const resp = await votacaoFase2(data);
            const tab = {
              regiao_central: 'REGIÃO CENTRAL',
              leste: 'ZONA LESTE',
              norte: 'ZONA NORTE',
              oeste: 'ZONA OESTE',
              sul: 'ZONA SUL'
            };
            setShowModalVotacao(false);
            Swal.fire({
              icon: 'warning',
              text: resp.success,
              confirmButtonText: 'Ok'
            });

            const votosPizzarias =
              JSON.parse(localStorage.getItem(`${email}_pizzarias`)) || [];

            if (!votosPizzarias.includes(zonaAtual)) {
              votosPizzarias.push(zonaAtual);
              localStorage.setItem(
                `${email}_pizzarias`,
                JSON.stringify(votosPizzarias)
              );
            }

            const zonasRestantes = Object.values(tab).filter(
              (zona) => !votosPizzarias.includes(zona)
            );

            let textRedirect = 'Obrigado por votar nesta pizzaria!';
            let buttonText = 'Voltar';

            if (zonasRestantes.length > 0 && zonasRestantes.length <= 6) {
              const proximaZona = zonasRestantes[0];
              buttonText = `Ir para ${proximaZona}`;
              textRedirect = `Obrigado por votar. Você ainda não votou na zona ${proximaZona}. Clique para votar!`;

              const proximaZonaKey = Object.keys(tab).find(
                (key) => tab[key] === proximaZona
              );

              if (proximaZonaKey) {
                window.scrollTo(0, 0);
                setTimeout(() => {
                  document.getElementById('pizzarias').scrollIntoView({
                    behavior: 'smooth'
                  });
                }, 500);

                setTimeout(() => {
                  const tabElement = document.querySelector(
                    `[data-tab-key="${proximaZonaKey}"]`
                  );

                  if (tabElement) {
                    tabElement.click();
                  }
                }, 500);
              }
            } else {
              textRedirect =
                'Obrigado por votar em todas as pizzarias! Sua participação é muito importante para nós.';
            }

            Swal.fire({
              icon: 'info',
              text: textRedirect,
              confirmButtonText: buttonText
            }).then(() => {
              setIsLoading(false);
            });
          } catch (error) {
            setShowModalVotacao(false);
            if (error.response.status === 422) {
              Swal.fire({
                timer: 2500,
                icon: 'error',
                showConfirmButton: false,
                text: 'Usuário já votou nessa categoria!'
              });
            } else {
              Swal.fire({
                timer: 3500,
                icon: 'error',
                showConfirmButton: false,
                text: 'Ops! Houve um erro, tente novamente mais tarde.'
              });
            }
            setIsLoading(false);
          }
        });
    });
  };

  const handleClickSSO = (social) => {
    const data = {
      pizzaria_id: idPizzaria
    };

    localStorage.setItem('vote_data', JSON.stringify(data));
    localStorage.setItem('last_zone', JSON.stringify(zonaAtual));

    if (social === 'google') {
      window.location.href = `${process.env.REACT_APP_API_URL}auth/login/google`;
    } else if (social === 'facebook') {
      window.location.href = `${process.env.REACT_APP_API_URL}auth/login/facebook`;
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleModal);
    return () => {
      document.removeEventListener('mousedown', handleModal);
    };
  }, []);

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = id;
        script.onload = () => {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };

    loadScriptByURL(
      'recaptcha-key',
      `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_KEY_RECAPTCHA}`,
      () => {}
    );
  }, []);

  return (
    <div className="in-vote">
      <div className="in-vote-modal" ref={modal}>
        <div className="in-vote-modal-grid">
          <div className="in-vote-modal-grid-title">
            <p>Confirmar voto em:</p>
            <p>{nomePizzaria}</p>
            <p>
              Para finalizar o voto precisamos fazer uma
              <br />
              confirmação por e-mail
            </p>
          </div>
          <div className="in-vote-modal-grid-email">
            <div className="in-vote-modal-grid-email-input">
              <input
                id="email"
                type="email"
                name="email"
                value={email}
                placeholder="Digite o seu e-mail"
                onChange={(e) => setEmail(e.target.value)}
              />
              <button
                disabled={email === '' || isLoading}
                type="button"
                onClick={handleVotacao}
              >
                {isLoading ? (
                  <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
                ) : (
                  'Confirmar'
                )}
              </button>
            </div>
            <div className="in-vote-modal-grid-email-or">
              <div />
              <span>ou</span>
              <div />
            </div>
            <div className="in-vote-modal-grid-email-btn">
              <button type="button" onClick={() => handleClickSSO('google')}>
                <img src={iconGoogle} alt={iconGoogle} />
                <span>Acessar com o google</span>
              </button>
              {/* <button type="button" onClick={() => handleClickSSO('facebook')}>
                <img src={iconFacebook} alt={iconFacebook} />
                <span>Acessar com o facebook</span>
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalVotacao;
